import ApiCore from "./apiCore";

export default class apiBase extends ApiCore {

}
